// Inefficient, but easier to understand
export const createListFromArray = (items) => {
  // First create an array with item as key
  var list = items.map((item) => {
    return { item: item };
  });

  // Now fill in previous and next
  const listLength = list.length;
  list.forEach((entry, index) => {
    const prevIndex = index === 0 ? listLength - 1 : (index - 1) % listLength;
    const prev = list[prevIndex];
    const nextIndex = (index + 1) % listLength;
    const next = list[nextIndex];

    entry.prev = prev;
    entry.next = next;
  });

  return list[0];
};

export const fetchItemsFromList = (current, count) => {
  const range = Array.from(Array(count).keys());
  let iterator = current.prev;

  return range.map(() => {
    iterator = iterator.next;
    return iterator.item;
  });
};
